import { defineMessages } from 'react-intl';

export default defineMessages({     
    policyholderRegistrationTermsAndConditionsPart1: {
        id: 'policyholder.registration.Terms and Conditions Part1',
        defaultMessage: '* By checking this box, you are affirming that you are a TWIA policyholder and you acknowledge and agree to these '
    },    
    policyholderRegistrationTermsAndConditionsTFPAPart1: {
        id: 'policyholder.registration.tfpa.Terms and Conditions Part1',
        defaultMessage: '* By checking this box, you are affirming that you are a TFPA policyholder and you acknowledge and agree to these '
    },    
    policyholderRegistrationTermsAndConditionsPart2: {
        id: 'policyholder.registration.Terms and Conditions Part2',
        defaultMessage: 'Terms and Conditions'
    },      
    policyholderRegistrationTermsAndConditionsPart3: {
        id: 'policyholder.registration.Terms and Conditions Part3',
        defaultMessage: '. Unauthorized use of CustomerEngage could subject you to legal action.'
    },        
    policyholderRegistrationTermsAndConditionLink: {
        id: 'policyholder.registration.Terms and Conditions Link',
        defaultMessage: 'https://www.twia.org/terms-and-conditions'
    },        
    policyholderRegistrationDuplicateRegistrationError: {
        id: 'policyholder.registration.duplicate.registration.Error',
        defaultMessage: 'This policy/offer {policyOrOfferNumber} is already linked to a TWIA Account. Please use the Sign In link to access your account.'
    },
    policyholderRegistrationDuplicateRegistrationErrorTFPA: {
        id: 'policyholder.registration.duplicate.registration.tfpa.Error',
        defaultMessage: 'This policy/offer {policyOrOfferNumber} is already linked to a TFPA Account. Please use the Sign In link to access your account.'
    },
    policyholderRegistrationInvalidPolicyOrOfferNumberTitle: {
        id: 'policyholder.registration.invalid.policynumber.title.Error',
        defaultMessage: 'Policy/Offer Format is Incorrect.'
    },
    policyholderRegistrationInvalidPolicyOrOfferNumber: {
        id: 'policyholder.registration.invalid.policynumber.Error',
        defaultMessage: 'Please enter your 14-character policy number, including the letters, (e.g., TWRD0100012345), or your 10-digit policy offer number (e.g., 1234567890) provided by your agent.'
    },
    policyholderRegistrationInvalidPolicyOrOfferNumberTFPA: {
        id: 'policyholder.registration.invalid.policynumber.tfpa.Error',
        defaultMessage: 'Please enter your 14-character policy number, including the letters, (e.g., TFPH0100012345), or your 10-digit policy offer number (e.g., 1234567890) provided by your agent.'
    },
    policyholderRegistrationInvalidDataTitle: {
        id: 'policyholder.registration.invalid.data.title.Error',
        defaultMessage: 'Invalid Data'
    },
    policyholderRegistrationInvalidData: {
        id: 'policyholder.registration.invalid.data.Error',
        defaultMessage: 'The information entered does not match our records.'
    },
    policyholderRegistrationErrorTitle: {
        id: 'policyholder.registration.title.Error',
        defaultMessage: 'Error'
    },         
    policyholderRegistrationError: {
        id: 'policyholder.registration.Error',
        defaultMessage: 'The system encountered an error'
    },    
    policyOrOfferToolTip: {
        id: 'policyholder.registration.policyoffer.Tooltip',
        defaultMessage: 'Your 14-character policy number, including the letters, (e.g., TWRD0100012345), or your 10-digit policy offer number (e.g., 1234567890) provided by your agent'
    },    
    policyOrOfferToolTipTFPA: {
        id: 'policyholder.registration.policyoffer.tfpa.Tooltip',
        defaultMessage: 'Your 14-character policy number, including the letters, (e.g., TFPH0100012345), or your 10-digit policy offer number (e.g., 1234567890) provided by your agent'
    },    
});
